import React from 'react'
import { PropTypes } from 'prop-types'
const FreightIcon = (props) => (
  <svg
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22.51 16.35"
    fill={props.fill ? props.fill : '#262626;'}
    width={props.width ? props.width : '30'}
    height={props.height ? props.height : '30'}
  >
    <g id="Layer_1-2">
      <path
        className="cls-1"
        d="m4.71,16.35c-.84,0-1.55-.29-2.14-.88-.59-.59-.88-1.3-.88-2.14H0V1.53c0-.41.15-.77.46-1.07s.67-.46,1.07-.46h14.81v4.27h2.69l3.48,4.63v4.43h-1.82c0,.84-.29,1.55-.88,2.14-.59.59-1.3.88-2.14.88s-1.55-.29-2.14-.88c-.59-.59-.88-1.3-.88-2.14h-6.93c0,.84-.29,1.55-.88,2.14-.59.59-1.3.88-2.14.88Zm0-1.53c.41,0,.76-.14,1.05-.43.29-.29.43-.64.43-1.05s-.14-.76-.43-1.05c-.29-.29-.64-.43-1.05-.43s-.76.14-1.05.43-.43.64-.43,1.05.14.76.43,1.05.64.43,1.05.43Zm-3.17-3.02h.56c.29-.46.66-.83,1.1-1.1.44-.27.94-.41,1.48-.41s1.04.14,1.5.42.82.64,1.11,1.09h7.52V1.53H1.53v10.26Zm16.14,3.02c.41,0,.76-.14,1.05-.43s.43-.64.43-1.05-.14-.76-.43-1.05-.64-.43-1.05-.43-.76.14-1.05.43-.43.64-.43,1.05.14.76.43,1.05.64.43,1.05.43Zm-1.33-5.22h4.76l-2.84-3.79h-1.92v3.79Z"
      />
    </g>
  </svg>
)

export default FreightIcon
FreightIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
}
